import { ContactUs, CopyrightFooter, DataGrid, FindAFoundation, MaterialInput } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import { ResourceAction } from 'app/redux/Resources/actions';
import * as React from 'react'
import { Button, Col, Panel, Row, Table } from 'react-bootstrap'

interface ITableData {
  years: any[]
  rows: any[]
}

interface IndexValue {
  name: string
  value: number
  className: string
  abbreviation: string
  annualValue: number
  threeYearValue: number
  fiveYearValue: number
}

interface IReportsState {
  isReportsTableShown: boolean
  isLoggedIn: boolean
  username: string
  key: string
}

class Reports extends Container<{}, IReportsState> {
  state = {
    isLoggedIn: false,
    username: '',
    key: '',
    isReportsTableShown: false,
  }

  mapAppStateToContainerState(appState: IAppState): IReportsState {
    const isLoggedIn = !!appState.User.username
    const username = appState.User.username
    const key = appState.User.token
    const tableData = { years: [], rows: [] }
    const summaryData = []
    return { isLoggedIn, username, key, isReportsTableShown: false }
  }

  componentWillMount() {
    super.componentWillMount()
  }

  componentDidMount() {
    const assetClassReturns = this.getUrlParameter('assetClassReturns')

    if (assetClassReturns) {
      document.getElementById('assetClassReturns').scrollIntoView()
    }
  }

  getUrlParameter(sParam: string): any {
    const hash = window.location.hash
    const search = (hash.indexOf('?') !== -1) ? hash.split('?')[1] : ''
    const sPageURL = decodeURIComponent(search)
    const sURLVariables = sPageURL.split('&')
    let sParameterName = []

    for (const variable of sURLVariables) {
      sParameterName = variable.split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  }

  downloadIndex() {
    const fileName = 'FoundationMarkSample.pdf'
    if (this.state.isLoggedIn) {
      //NOTE: download file
      ResourceAction.getFileUrl(this.state.username, this.state.key, fileName)
        .then((response) => {
          window.open(response.resource.url)
        })
        .catch((error) => {
          // tslint:disable-next-line:no-console
          console.log(error)
        })
    } else {
      //NOTE: Redirect to login page
      location.hash = '#/login?fileName=' + fileName + '&page=reports'
    }
  }

  setReportsTableShown() {
    this.setState({ isReportsTableShown: true }, () => {
      window.scroll(0, 0)
    })
  }

  getPerformanceContent() {
    return (
      <section className="container margin-bottom" style={{ overflowX: 'hidden' }}>
        <section className="animated fadeIn">
          <h3 style={{ marginTop: 0 }}>FoundationMark Performance Reports</h3>
          <p>Performance reports provide foundation officers and trustees insights into the investment performance of the foundation universe and how their performance compares. The report includes the foundation's relative performance, FoundationMark Quadrant ranking and the FoundationMark Peer Group Analysis. Reports are complimentary and are available to foundation trustees and officers only by request. If you are a foundation trustee or officer and would like your report, please click Request Performance Report.</p>

          <Row className="margin-y">
            <Col md={6} className="margin-y-lg">
              <img src="/assets/img/FoundationMarkPerformanceReportOct15.png" width="525" height="250" />
            </Col>
            <Col md={6} className="margin-y-sm">
              <Row className="margin-y">
                <Col md={12} className="margin-y-sm">
                  <Button bsStyle="info" bsSize="lg" block href="#/faq">FAQs</Button>
                </Col>
                <Col md={12} className="margin-y-sm">
                  <Button bsStyle="info" bsSize="lg" block href="#/sampleReport" >See Select Pages from a Sample Report</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </section>
      </section>
    )
  }

  render() {
    return (
      <section>
        {this.state.isReportsTableShown ?
          null :
          <div className="padding-top">
            {this.getPerformanceContent()}
          </div>
        }

        <div className="margin-bottom-lg">
          <div className="well well-info" style={{ marginBottom: 0 }}>
            <div className="container animated fadeIn">
              <header className="margin-bottom">
                <h2 className="hidden-xs">
                  Are you a Foundation?&nbsp;
                <small>Request Performance Reports</small>
                </h2>
                <h3 className="visible-xs">Are you a Foundation?</h3>
              </header>

              <section className="margin-bottom">
                <FindAFoundation onTableShow={() => this.setReportsTableShown()} />
              </section>
            </div>
          </div>
        </div>

        {this.state.isReportsTableShown ?
          this.getPerformanceContent()
          : null
        }

        <ContactUs />
        <CopyrightFooter />
      </section>
    )
  }
}

export {
  Reports
}



// WEBPACK FOOTER //
// ./src/app/containers/Reports/index.tsx